import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * `/` redirige al dashboard. El guard de auth en `_private/route.tsx`
 * decide si el usuario puede ver `/dashboard` o lo manda a `/login`.
 */
export const Route = createFileRoute('/')({
  beforeLoad: () => {
    // TanStack Router usa `throw redirect(...)` como flujo de control;
    // el objeto thrown no es un Error, es la senal que el router intercepta.
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({ to: '/dashboard' });
  },
});
